import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircularProgress as Spinner, Fade, Stack, Typography, } from '@mui/material';
import { useTranslation } from 'react-i18next';
export const LoadingMask = ({ fullScreen }) => {
    const { t } = useTranslation('common');
    const oneSecondInMilliseconds = 1000;
    return (_jsx(Fade, { easing: "cubic-bezier(1,0,1,0)", in: true, timeout: fullScreen ? oneSecondInMilliseconds : 0, children: _jsxs(Stack, { alignItems: "center", margin: "auto", width: "100%", height: "100%", spacing: 4, children: [fullScreen ? (_jsx(Typography, { variant: "h1", color: "secondary", sx: { fontWeight: 700 }, children: t('body.appName') })) : null, _jsx(Spinner, { "aria-busy": true, ...(fullScreen && { size: '4rem' }) })] }) }));
};
